import React from "react";
import moment from "moment";
import { CircularProgress, Modal } from "@mui/material";

import { useAppDispatch } from "application/store";
import { RegistrationForQAModalProps } from "./models";
import { registerWebinar } from "application/store/Deal/actions";
import { GlobalSliceAction } from "application/store/global/slice";
import { useAmplitude, AmplitudeEvent } from "application/hooks/useAmplitude";

import { Button, OutlineButton } from "application/components";

import {
  Card,
  Content,
  Container,
  DateContainer,
  ButtonsSection,
  LoaderContainer,
  BackgroundContainer,
} from "./styles";
import { CalendarIcon } from "application/assets";
import backgroundSource from "./assets/background.png";

const RegistrationForQAModal = ({
  deal,
  loading,
  visible,
  onClose,
  toggleQuestionModal,
}: RegistrationForQAModalProps) => {
  const dispatch = useAppDispatch();
  const { trackEvent } = useAmplitude();

  const deal_title = deal?.title;
  const responsible = deal?.overview.team.find((x) => x.isResponsibleForQa);
  const fullName = `${responsible?.firstName} ${responsible?.lastName}`;
  const date = moment(deal?.webinarStartTime).format("MMMM DD, YYYY HH:mm");

  const showContactSupport = () => {
    const description =
      "We couldn’t register you due to a technical issue. Please contact support.";
    dispatch(GlobalSliceAction.setContactSupportModal(description));
  };

  const onSubmit = async () => {
    if (!deal?.id) {
      return;
    }
    trackEvent(AmplitudeEvent["Deals_Q&A_In_button"], { deal_title });
    try {
      await dispatch(registerWebinar(deal.id)).unwrap();
      onClose();
      toggleQuestionModal();
    } catch (error) {
      onClose();
      showContactSupport();
    }
  };

  return (
    <Modal open={visible}>
      <Container>
        <Card>
          <h1>Complete your registration for Q&A</h1>

          <BackgroundContainer>
            <img alt="user" className="user" src={responsible?.imageUrl} />
            <img alt="background" className="background" src={backgroundSource} />
          </BackgroundContainer>

          <Content>
            <h5>{fullName}</h5>
            <small>{responsible?.title}</small>
            <p>{fullName} will personally answer your question about the deal.</p>
          </Content>

          <DateContainer>
            <CalendarIcon />
            <span>{date}</span>
          </DateContainer>

          <ButtonsSection>
            {loading ? (
              <LoaderContainer>
                <CircularProgress size="36px" />
              </LoaderContainer>
            ) : (
              <React.Fragment>
                <Button type="submit" onClick={onSubmit}>
                  Register
                </Button>
                <OutlineButton onClick={onClose}>Cancel</OutlineButton>
              </React.Fragment>
            )}
          </ButtonsSection>
        </Card>
      </Container>
    </Modal>
  );
};

export default RegistrationForQAModal;
